import {
  EtrmConfigActionEnum,
  IFetchEtrmConfigAction,
  IFetchEtrmConfigSuccessAction,
  IFetchEtrmConfigFailedAction,
  IPostEtrmConfigAction,
  IPostEtrmConfigFailedAction,
  IPostEtrmConfigSuccessAction
} from '.';
import {
  IEtrmConfig,
} from '../../services';

export const FetchEtrmConfigAction = () => {
    return {
        type: EtrmConfigActionEnum.FetchEtrmConfig,
        state: { loading: true },
    } as IFetchEtrmConfigAction;
};

export const FetchEtrmConfigSuccessAction = (etrmConfigs: IEtrmConfig[]) => {
    return {
        type: EtrmConfigActionEnum.FetchEtrmConfigSuccess,
        state: { loading: false, etrmConfigs: etrmConfigs },
    } as IFetchEtrmConfigSuccessAction;
};

export const FetchEtrmConfigFailedAction = (message: string) => {
    return {
      type: EtrmConfigActionEnum.FetchEtrmConfigFailed,
      state: { loading: false, exceptionMessage: message },
    } as IFetchEtrmConfigFailedAction;
};

export const PostEtrmConfigAction = (etrmConfig: IEtrmConfig) => {
  return {
    type: EtrmConfigActionEnum.PostEtrmConfig,
    state: { loading: true, etrmConfig: etrmConfig },
  } as IPostEtrmConfigAction;
};

export const PostEtrmConfigSuccessAction = () => {
  return {
    type: EtrmConfigActionEnum.PostEtrmConfigSuccess,
    state: { loading: false},
  } as IPostEtrmConfigSuccessAction;
};

export const PostEtrmConfigFailedAction = (message: string) => {
  return {
    type: EtrmConfigActionEnum.PostEtrmConfigFailed,
    state: { loading: false, exceptionMessage: message },
  } as IPostEtrmConfigFailedAction;
};


